export const FILTERS_MOBILE_SHEET_TEST_IDS = {
  shell: 'filters-mobile-sheet',
  selectRow: 'filters-mobile-sheet-select-row',
} as const

export const GATEWAY_TIME_RANGE_FILTER_TEST_IDS = {
  root: 'gateway-time-range-filter',
} as const

export const TIME_RANGE_FILTER_TEST_IDS = {
  root: 'time-range-filter',
  trigger: 'time-range-filter-trigger',
  content: 'time-range-filter-content',
  customAndActions: 'time-range-filter-custom-and-actions',
  customRangeSection: 'time-range-filter-custom-range',
} as const
